import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';

import {NzAvatarModule} from 'ng-zorro-antd/avatar';
import {NzBadgeModule} from 'ng-zorro-antd/badge';
import {NzDropDownModule} from 'ng-zorro-antd/dropdown';
import {NzListModule} from 'ng-zorro-antd/list';
import {NzDrawerModule} from 'ng-zorro-antd/drawer';
import {NzInputModule} from 'ng-zorro-antd/input';
import {NzButtonModule} from 'ng-zorro-antd/button';

import {HeaderComponent} from './header/header.component';
import {FooterComponent} from './footer/footer.component';
import {SearchComponent} from './search/search.component';

import {SharedModule} from '@shared/shared.module';
import {ThemeConstantService} from '@shared/service/theme-constant/theme-constant.service';
import {NzTagModule} from 'ng-zorro-antd/tag';
import {SideNavComponent} from './side-nav/side-nav.component';
import {SideNavDirective} from '@shared/directives/side-nav.directive';
import {NgScrollbarModule} from 'ngx-scrollbar';

const antdModule = [
  NzAvatarModule,
  NzBadgeModule,
  NzDropDownModule,
  NzListModule,
  NzDrawerModule,
  NzInputModule,
  NzButtonModule,
  NzTagModule
];

@NgModule({
  exports: [
    CommonModule,
    HeaderComponent,
    SearchComponent,
    SideNavComponent,
    SideNavDirective,
    FooterComponent
  ],
  imports: [
    RouterModule,
    CommonModule,
    SharedModule,
    NgScrollbarModule,
    ...antdModule
  ],
  declarations: [
    HeaderComponent,
    SearchComponent,
    FooterComponent,
    SideNavComponent,
    SideNavDirective
  ],
  providers: [
    ThemeConstantService
  ]
})

export class LayoutComponentsModule {
}
